import { render, staticRenderFns } from "./InvestorTaxProfile.vue?vue&type=template&id=658c9118&"
import script from "./InvestorTaxProfile.vue?vue&type=script&lang=js&"
export * from "./InvestorTaxProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports